module.exports = __webpack_public_path__ + "static/img/live-end-img.c251417.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/developerConference/live-end-img.png
// module id = WECr
// module chunks = 86